import React from "react";
import { AppBar, Toolbar, Box } from "@mui/material";

import logo from "../assets/mealno-brand-logo.svg";

export default function Header() {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: "#F8D548", // 🎨 Theme: Soft Cream (Matches Home Header)
        top: 0,
        margin: 0,
        padding: 0,
        borderBottom: "none"
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: "64px !important",
          padding: "0 16px !important",
          margin: 0,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        {/* ✅ Render as a standard image rather than a CSS mask */}
        <Box
          component="img"
          src={logo}
          alt="Mealno Logo"
          sx={{
            height: 28,
            width: "auto", // Allows the width to scale proportionally with the height
            maxWidth: 110, // Keeps it constrained to your original intended size
            objectFit: "contain"
          }}
        />
        
        {/* Notification button temporarily removed as requested */}
      </Toolbar>
    </AppBar>
  );
}